const CameraIcon: React.FC<{ fill?: string }> = ({ fill }) => {
  return (
    <svg
      width="24"
      height="21"
      viewBox="0 0 24 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 3H18L15.5 0H8.5L6 3H2C1.46957 3 0.960859 3.21071 0.585786 3.58579C0.210714 3.96086 0 4.46957 0 5L0 19C0 19.5304 0.210714 20.0391 0.585786 20.4142C0.960859 20.7893 1.46957 21 2 21H22C22.5304 21 23.0391 20.7893 23.4142 20.4142C23.7893 20.0391 24 19.5304 24 19V5C24 4.46957 23.7893 3.96086 23.4142 3.58579C23.0391 3.21071 22.5304 3 22 3ZM12 17C10.9122 17 9.84883 16.6774 8.94436 16.0731C8.03989 15.4687 7.33494 14.6098 6.91866 13.6048C6.50238 12.5998 6.39346 11.4939 6.60568 10.427C6.8179 9.36011 7.34172 8.3801 8.11091 7.61091C8.8801 6.84172 9.86011 6.3179 10.927 6.10568C11.9939 5.89346 13.0998 6.00238 14.1048 6.41866C15.1098 6.83494 15.9687 7.53989 16.5731 8.44436C17.1774 9.34883 17.5 10.4122 17.5 11.5C17.5 12.9587 16.9205 14.3576 15.8891 15.3891C14.8576 16.4205 13.4587 17 12 17Z"
        fill={fill || "#FCF7F7"}
      />
    </svg>
  );
};

export default CameraIcon;
